import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceSetupListEntityState} from "../reducers/ecommerce-setup-list.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceSetupListState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceSetupList);

export const getEcommerceSetupListData = createSelector(getEcommerceSetupListState,
  (state: IEcommerceSetupListEntityState) => state
);

export const getEcommercePaymentMode = createSelector(getEcommerceSetupListState,
  (state: IEcommerceSetupListEntityState) => {
    return state?.list?.payment_mode;
  }
);

export const getEcommerceSetupListLoaded = createSelector(getEcommerceSetupListState,
  (state: IEcommerceSetupListEntityState) => state.loaded
);
